var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 35,
    viewBox: "0 0 31 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3335 0C11.9235 0 8.6531 1.35463 6.24185 3.76588C3.83059 6.17714 2.47596 9.4475 2.47596 12.8575V20.5421L0.960916 22.0571C0.661315 22.3568 0.457295 22.7386 0.374648 23.1542C0.292 23.5698 0.334437 24.0006 0.496592 24.3921C0.658747 24.7837 0.93334 25.1183 1.28566 25.3538C1.63797 25.5893 2.0522 25.715 2.47596 25.7151H28.191C28.6148 25.715 29.029 25.5893 29.3813 25.3538C29.7337 25.1183 30.0082 24.7837 30.1704 24.3921C30.3326 24.0006 30.375 23.5698 30.2923 23.1542C30.2097 22.7386 30.0057 22.3568 29.7061 22.0571L28.191 20.5421V12.8575C28.191 9.4475 26.8364 6.17714 24.4251 3.76588C22.0139 1.35463 18.7435 0 15.3335 0ZM15.3335 34.2868C13.6285 34.2868 11.9933 33.6094 10.7877 32.4038C9.58204 31.1982 8.90473 29.563 8.90473 27.858H21.7623C21.7623 29.563 21.0849 31.1982 19.8793 32.4038C18.6737 33.6094 17.0385 34.2868 15.3335 34.2868Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.8a8baf85956fa4d2cae45cd5c7a432ad.svg";
export { ForwardRef as ReactComponent };